import { CAMPAIGN_TYPE } from "./campaign";

export const D2C_BANNER = [
  {
    lang: "en",
    src: "https://storage.googleapis.com/ps-asset/motor/d2c/banners/quote_page/special/cta_banner_main-en.png",
    show: true,
    alt: "",
  },
  {
    lang: "bm",
    src: "https://storage.googleapis.com/ps-asset/motor/d2c/banners/quote_page/special/cta_banner_main-bm.png",
    show: true,
    alt: "",
  },
];

export const D2C_MOBILE_BANNER = [
  // remove the below if passed 12 sept
  {
    lang: "en",
    src: "https://storage.googleapis.com/ps-asset/motor/d2c/banners/quote_page/special/cta_banner_main-mobile-en.png",
    show: true,
    alt: "",
  },
  {
    lang: "bm",
    src: "https://storage.googleapis.com/ps-asset/motor/d2c/banners/quote_page/special/cta_banner_main-mobile-bm.png",
    show: true,
    alt: "",
  },
];

export const DEFAULT_CTA_BANNER = [
  {
    lang: "en",
    src: "https://storage.googleapis.com/ps-asset/motor/d2c/banners/quote_page/special/cta_banner_mini-en.png",
    show: true,
    alt: "",
  },
  {
    lang: "bm",
    src: "https://storage.googleapis.com/ps-asset/motor/d2c/banners/quote_page/special/cta_banner_mini-bm.png",
    show: true,
    alt: "",
  },
];

export const AFFILIATE_BANNER = [
  {
    partner: "carsome",
    lang: "en",
    //src: "https://storage.googleapis.com/ps-asset/motor/partner/carsome/carsome-banner-small.png",
    src: "https://storage.googleapis.com/ps-asset/motor/partner/carsome/carsome-banner-july-campaign-en.jpg",
    alt: "",
  },
  {
    partner: "carsome",
    lang: "bm",
    src: "https://storage.googleapis.com/ps-asset/motor/partner/carsome/carsome-banner-july-campaign-bm.jpg",
    alt: "",
  },
  {
    partner: "wapcar",
    lang: "en",
    src: "https://storage.googleapis.com/ps-asset/motor/partner/wapcar/wapcar-banner-july-campaign-en.jpg",
    alt: "",
  },
  {
    partner: "wapcar",
    lang: "bm",
    src: "https://storage.googleapis.com/ps-asset/motor/partner/wapcar/wapcar-banner-july-campaign-bm.jpg",
    alt: "",
  },
    {
    partner: "carlist",
    lang: "en",
    src: "https://storage.googleapis.com/ps-asset/motor/partner/carlist/carlist-banner-july-campaign-en.jpg",
    alt: "",
  },
  {
    partner: "carlist",
    lang: "bm",
    src: "https://storage.googleapis.com/ps-asset/motor/partner/carlist/carlist-banner-july-campaign-bm.jpg",
    alt: "",
  },
];
